import authenticationReducerFromSlice from "./store/authenticationSlice";

export const authenticationReducer = authenticationReducerFromSlice;
